<app-floorplan-upload-overlay (floorplan$)="onPlanUploaded($event)">
  <form odxForm [formGroup]="floorplanForm" class="container scroll h-100 padding-24">
    <!-- prettier-ignore -->
    @if((isTablet$ | async) === false) {
    @if (floorplans.length === 0) {
      <h6 class="odx-subtitle-6" i18n="@@floorplanUpload.noFloorplanYet">Sie haben noch keinen Grundrissplan hinzugefügt.</h6>
    }
    <div odxLayout="grid 3@desktop 4@tablet 6@phone" class="mb-36">
      @for (plan of floorplans; track plan) {
        <app-new-project-file-card
          i18n-title="@@floorplanUpload.fileCard.header"
          title="Neuer Grundrissplan"
          [fileName]="plan.name"
          [fileUrl]="plan.fileUrl"
          [isFloorplan]="true"
          (delete$)="onDelete(plan)"
          (submit$)="onCardSubmit($event, plan)"
          #floorplanCard
        ></app-new-project-file-card>
      }
    </div> }
    @else {
      <app-mobile-floorplans-warning></app-mobile-floorplans-warning>
    }
  </form>
</app-floorplan-upload-overlay>
